/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('NewTicketCtrl', function($scope, $location, Ticket, ErrorThrower) {
    $scope.selected_tag = null;
    const errorManager        = new ErrorThrower({
        'Forbidden': 'Vous ne pouvez pas creer de ticket pour le moment, veuillez réessayer ulterieurement'});
    $scope.loading      = false;
    $scope.subjects     = [
        {
            name: 'Assiduité : retard, absence, e-learning, distanciel',
            tags: ['pedago', 'assiduite']
        },
        {
            name: 'Question ou problème pédagogique',
            tags: ['pedago', 'suivi']
        },
        {
            name: 'Question ou problème technique',
            tags: ['pedago', 'jawa']
        },
        {
            name: 'Demande de documents',
            tags: ['pedago', 'document']
        },
        {
            name: 'Alternance : recherche d\'entreprise, montage ou question sur les contrats',
            tags: ['reen']
        },
        {
            name: 'Autre',
            tags: ['pedago', 'divers']
        }
    ];

    $scope.all  = [];
    $scope.todo =
        {users : []};

    $scope.refreshAll = function(query) {
        if (query.length < 3) { return; }

        return Ticket
        .getUsers({
            q: query})
        .$promise
        .then(users => $scope.all = users.data).catch(api_error => errorManager.minor(api_error.statusText));
    };

    return $scope.sendTicket = function() {
        if (true === $scope.loading) { return; }

        $scope.loading  = true;
        $scope.error    = undefined;
        const ticket          = new Ticket;
        if ($scope.selected_tag != null ? $scope.selected_tag.tags : undefined) { ticket.tags     = $scope.selected_tag.tags; }
        ticket.users    = $scope.todo.users;
        ticket.title    = $scope.title;
        ticket.message  = $scope.message;
        return ticket
        .$save()
        .then(() => $location.path('/tickets')).catch(function(api_error) {
            errorManager.minor(api_error.statusText);
            return $scope.loading = false;
        });
    };
});
